import ReactTable from 'react-table';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SubscriptionChargeForm from '../containers/SubscriptionChargeForm';
import Money from '../../../common/money';
import AdminActionButton from '../../shared/Buttons/AdminActionButton';
import RefundModal from '../../../common/RefundModal';
import Date from '../../../common/date';
import Time from '../../../common/Time';

const SubscriptionCharges = ({
  subscriptionCharges,
  setShowForm,
  showForm,
  subscriptionId,
  currency,
  refundModalOff,
  refundModalIsOn,
  selectedCharge,
  refund,
  openRefundModal,
}) => (
  <Fragment>
    <div>
      <div className="u-mt u-mb u-text-right">
        <AdminActionButton
          type="button"
          className="c-btn c-btn--small u-ml"
          display-if={subscriptionId}
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? 'Hide form' : 'New charge'}
        </AdminActionButton>
      </div>
      <SubscriptionChargeForm display-if={showForm} currency={currency} />
      {}
      <ReactTable
        data={subscriptionCharges}
        showPagination={false}
        minRows={0}
        className="c-table-new c-table--small c-table--border c-no-hover c-no-fixed-rows u-mt--"
        columns={[{
          Header: 'Description',
          accessor: 'desc',
          id: 'desc',
          className: 'no-text-overflow u-break-word',
        }, {
          Header: 'Price',
          accessor: 'price',
          id: 'price',
          Cell: props => <Money cents={props.value} currency={currency} />,
        }, {
          Header: 'Refunded',
          accessor: 'refundedAmount',
          id: 'refundedAmount',
          Cell: props => props.value ? <Money cents={props.value} currency={currency} /> : <span>-</span>,
        },
        {
          Header: 'Charged at',
          accessor: 'createdAt',
          id: 'createdAt',
          Cell: props => (props.value ? (<span>
            <Date>{props.value}</Date>
            <br />
            <Time>{props.value}</Time>
          </span>) : <span>-</span>),
        },
        {
          Header: 'Actions',
          accessor: 'id',
          id: 'id',
          Cell: props =>
            <button
              type="button"
              className="c-btn c-btn--small u-ph- c-btn--red"
              onClick={() => openRefundModal(props.original)}
              display-if={props.original.refundedAmount < props.original.price}
            >Refund</button>
          ,
        }]}
      />
    </div>
    <RefundModal
      title="Refund"
      close={refundModalOff}
      item={selectedCharge}
      refund={refund}
      currency={currency}
      canCustomRefund
      display-if={refundModalIsOn}
    />
  </Fragment>
  );

SubscriptionCharges.propTypes = {
  subscriptionCharges: PropTypes.array,
  subscriptionId: PropTypes.string,
  setShowForm: PropTypes.func.isRequired,
  showForm: PropTypes.bool,
  refundModalIsOn: PropTypes.bool.isRequired,
  refundModalOff: PropTypes.func.isRequired,
  selectedCharge: PropTypes.object.isRequired,
  refund: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  openRefundModal: PropTypes.func.isRequired,
};

SubscriptionCharges.defaultProps = {
  subscriptionCharges: [],
  subscriptionId: '',
  showForm: false,
};

export default SubscriptionCharges;

